import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {DrugManagementPlanDTO} from '../models/DrugManagementPlanDTO';

@Injectable({
  providedIn: 'root'
})
export class DrugManagementPlanService {

  private url = environment.baseUrl + '/drug-management-plan';

  constructor(private httpClient: HttpClient) {
  }

  getListOfDrugManagementPlans(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<DrugManagementPlanDTO>> {
    return this.httpClient.post<PagedResponseDTO<DrugManagementPlanDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveDrugManagementPlan(drugManagementPlanDTO: DrugManagementPlanDTO): Observable<DrugManagementPlanDTO> {
    return this.httpClient.post<DrugManagementPlanDTO>(this.url, drugManagementPlanDTO);
  }

  deleteDrugManagementPlan(drugManagementPlanId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + drugManagementPlanId);
  }

  getDrugManagementPlan(drugmanagementPlanId: number): Observable<DrugManagementPlanDTO> {
    return this.httpClient.get<DrugManagementPlanDTO>(this.url + '/' + drugmanagementPlanId);
  }
}
